import { mapAnnouncement } from '../../statusBar/announcementsService';
import announcementExecutor from './announcementExecutor';
import contestExecutor from './contestExecutor';
import soundExecutor from './soundExecutor';
import spinningWheelExecutor from './spinningWheelExecutor';
import textExecutor from './textExecutor';
import userExecutor from './userExecutor';
import youtubeExecutor from './youtubeExecutor';
import giphyExecutor from './giphyExecutor';
import vimeoExecutor from './vimeoExecutor';

const executorProxy = (options, onDone, { endEvent, prolong }) => {
	const { notification_type } = options;
	switch (notification_type) {
	case 'sound':
		return soundExecutor({
			sound: options.sound,
			playCount: options.number_of_plays,
		}, onDone);
	case 'text':
		return textExecutor({
			title: options.title,
			subtitle: options.subtitle,
			duration: options.duration,
		}, onDone);
	case 'member':
		return userExecutor({
			name: options.member_name,
			avatar: options.member_avatar,
			text: options.text,
			duration: options.duration,
			animation: options.animation,
		}, onDone);
	case 'youtube':
		return youtubeExecutor({
			videoId: options[ 'video_id' ],
			start: options[ 'video_start' ],
			end: options[ 'video_end' ],
			playCount: options[ 'number_of_plays' ],
			duration: options.duration,
			text: options.text,
			mute: options.mute,
		}, onDone, { endEvent, prolong });
	case 'spinning_wheel':
		return spinningWheelExecutor({
			prizes: options[ 'prizes' ],
			winner: options[ 'winner' ],
			title: options[ 'title' ],
			winnerAngle: options[ 'angle' ]
		}, onDone);
	case 'contest':
		return contestExecutor(options, onDone);
	case 'announcement':
		return announcementExecutor(mapAnnouncement(options), onDone);
	case 'giphy':
		return giphyExecutor({
			videoId: options[ 'video_id' ] || options[ 'url' ],
			duration: options.duration,
			text: options.text,
			spin: options.spin,
			sound: options.sound,
			playCount: options.number_of_plays,
		}, onDone, { endEvent, prolong });
	case 'video':
		return vimeoExecutor({
			videoId: options[ 'video_id' ] || options[ 'url' ],
			startTime: options[ 'video_start' ] || options[ 'start_time' ],
			endTime: options[ 'video_end' ] || options[ 'end_time' ],
			duration: options.duration,
			text: options.text,
			muted: options.muted,
		}, onDone, { endEvent, prolong });
	default:
		// eslint-disable-next-line no-undef
		log('Unknown notification type!');
		onDone();
	}
};

export default executorProxy;
